import { logger } from 'client/utils/logger/logger';

let pbjsLoadPromise = null;
const SCRIPT_LOAD_TIMEOUT_MS = 1500;

export function ensurePbjsLoaded(src, integrity = null) {
  if (typeof window !== 'undefined' && typeof window.pbjs?.requestBids === 'function') {
    return Promise.resolve(window.pbjs);
  }

  if (!src) {
    return Promise.resolve(false);
  }

  if (pbjsLoadPromise) {
    return pbjsLoadPromise;
  }

  pbjsLoadPromise = new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      resolve(false);
      return;
    }

    const scriptTag = document.createElement('script');
    scriptTag.src = src;
    scriptTag.async = true;
    scriptTag.type = 'text/javascript';

    // Add integrity and crossorigin attributes for security when integrity is provided
    if (integrity) {
      scriptTag.integrity = integrity;
      scriptTag.crossOrigin = 'anonymous';
    }

    const timer = setTimeout(() => {
      scriptTag.onload = null;
      scriptTag.onerror = null;
      scriptTag.remove();
      pbjsLoadPromise = null;
      logger?.warn('Prebid script loading timed out; continuing with GPT-only ads.', {
        event: 'prebid_script_load_timeout',
        timeoutMs: SCRIPT_LOAD_TIMEOUT_MS,
        src,
      });
      reject(new Error('Prebid script loading timed out'));
    }, SCRIPT_LOAD_TIMEOUT_MS);
    scriptTag.onerror = err => {
      clearTimeout(timer);
      scriptTag.remove();
      pbjsLoadPromise = null;
      reject(err);
    };

    scriptTag.onload = () => {
      clearTimeout(timer);
      resolve(window.pbjs || false);
    };

    document.head.appendChild(scriptTag);
  });

  return pbjsLoadPromise;
}
